<script>
    export let label;
    export let id;
</script>

<input class="form-element mr-1" id="{id}" type="checkbox" on:click>
<label for="{id}">{label}</label>